import React, { useState, useEffect } from "react";

export default function Search({ onSearchResults, onDemoSearch, isUsingDemo }) {
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = () => {
    if (isUsingDemo) {
      // Use demo search when API is unavailable
      if (onDemoSearch) {
        onDemoSearch(searchValue);
      }
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
    
    fetch(`${apiUrl}/api/search/${searchValue}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch search results");
        }
        return response.json();
      })
      .then((data) => {
        if (onSearchResults) {
          onSearchResults(data);
        }
      })
      .catch((error) => {
  console.error("Error fetching search results:", error);
  console.warn("API unavailable, using demo search.");
        if (onDemoSearch) {
          onDemoSearch(searchValue);
        }
      });
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  useEffect(() => {
    // Optionally, you can automatically perform the search on component mount
    // handleSearch();
  }, [searchValue]);

  return (
    <div className="search-container">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <input
          type="text"
          value={searchValue}
          onChange={handleInputChange}
          placeholder="Search products..."
        />
        <button type="submit">Search</button>
      </form>
    </div>
  );
}